export default __webpack_public_path__ + "static/media/Icon-feather-map-pin.faf4d10a.svg";